import React from 'react';
import {AppText} from './Typography';
import {formatDate, formatTime} from '../../utils/dateUtils';

interface DateTimeDisplayProps {
  dateString: string;
  className?: string;
  dateClassName?: string;
  timeClassName?: string;
  showTime?: boolean;
}

/**
 * Unified DateTimeDisplay Component
 * Displays date and time on two separate lines for better readability
 * Used across all tables in the application for consistent date/time formatting
 */
const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({
  dateString,
  className = '',
  dateClassName = 'font-medium',
  timeClassName = 'text-xs text-gray-500',
  showTime = true
}) => {
  if (!dateString) {
    return <AppText className="text-gray-500">-</AppText>;
  }

  return (
    <div className={`space-y-1 text-right ${className}`}>
      <AppText className={dateClassName}>
        {formatDate(dateString)}
      </AppText>
      {showTime && (
        <AppText className={`block ${timeClassName}`}>
          {formatTime(dateString)}
        </AppText>
      )}
    </div>
  );
};

export default DateTimeDisplay;

